import { mapIdAndPromtToValueQuestions, mapIdTitleToValueName } from '@/modules/utils/simpleSelect'
import SectorsList from '../layout/pages/SectorsCards.vue'
import { createStore } from 'vuex'
import ExtinguisherService from '../service/extinguisher.service'
import { storeApp } from '@/store'
import { showToast as toast } from '@/helpers/UseToasts'

export const dataExtinguisher = createStore({
  state: () => {
    return {

      componentActive: SectorsList,
      backToComponent: 'SectorsList',
      pageTitle: 'AVALIAÇÕES',
      pageSubTitle: 'Gerencie suas provas facilmente',
      buttonActive: true,

      assessments: [], // list

      // component anterior - remover
      sectors: [], // list
      sectorId: undefined,
      itemsBySector: [],

      // combo
      trainingCollect: [],
      questionsCollect: [],

      form: {
        title: '',
        min_grade_required: 0,
        max_grade: 10,
        max_attempts: 1,
        time_limit_s: null,

        // default
        shuffle_questions: true,
        shuffle_options: true,
        is_active: true,
        event_id: null,
        questionSelected: null,
        answerOptionsCollect: []
      },
      loading: false,
      errors: null,

      // questões
      questionCollect: [],
      question: {
        title: null,
        options: []
      },

      sectorForm: {
        title: undefined,
        category: undefined,
        resum: undefined,
        banner: undefined,
        content: undefined,
        image: undefined,
        imageName: undefined
      },
      itensForm: {
        name: undefined,
        type: undefined,
        category: undefined,
        values: {}, // components form

        description: undefined,
        check_every: undefined,
        next_check: undefined,
        th_expiration: undefined,
        validity_expiration: undefined
      },
      maintenanceForm: {
        type: undefined,
        values: {},
        checklist: [],
        carried_out_in: undefined,
        images: undefined,
        imagesName: undefined
      }
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    backToComponent: (state) => state.backToComponent,

    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
    getIfButtonActive: (state) => state.buttonActive,
    getSectors: (state) => state.sectors,
    getAssessments: (state) => state.assessments,
    getItensBySector: (state) => state.itemsBySector,

    //
    getTrainingCollect: (s) => s.trainingCollect,
    getQuestionCollect: (s) => s.questionsCollect,
    getAnswerOptionsCollect: (s) => s.form.answerOptionsCollect,
    form: (s) => s.form,
    loading: (s) => s.loading,
    errors: (s) => s.errors

  },
  mutations: {
    // modal
    ADD_QUESTIONS (state, payload) {
      if (!Array.isArray(state.question.options)) {
        state.question.options = []
      }

      state.question.options.push(payload)
    },
    // opções da prova
    ADD_OPTION (state, payload) {
      if (!state.questionCollect) {
        state.questionCollect = []
      }

      state.questionCollect.push(payload)
    },
    // opções da prova
    ADD_QUESTIONS_ANSWER (state, payload) {
      if (!Array.isArray(state.form.answerOptionsCollect)) {
        state.form.answerOptionsCollect = []
      }

      const exists = state.form.answerOptionsCollect.some(
        item => item.value === payload.value
      )

      if (exists) return

      state.form.answerOptionsCollect.push(payload)
    },

    RESET_MAINTENANCE (state) {
      state.maintenanceForm.values.motivo = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.imagesName = undefined
      state.maintenanceForm.values.images = undefined

      state.maintenanceForm.checklist = []
      state.maintenanceForm.carried_out_in = undefined
      state.maintenanceForm.images = undefined
      state.maintenanceForm.imagesName = undefined
    },
    // RESET_FORM (state) {
    //   state.sectorForm.title = undefined
    //   state.sectorForm.category = undefined
    //   state.sectorForm.resum = undefined
    //   state.sectorForm.banner = undefined
    //   state.sectorForm.content = undefined
    //   state.sectorForm.image = undefined
    //   state.sectorForm.imageName = undefined
    // },
    SET_COMPONENT_ACTIVE (state, value) {
      state.componentActive = value
    },
    SET_ALL_ASSESSMENTS (state, value) {
      state.assessments = []
      state.assessments = value
    },
    SET_PAGE_TITLE (state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE (state, value) {
      state.pageSubTitle = value
    },
    SET_IF_BUTTON_ACTIVE (state, value) {
      state.buttonActive = value
    },
    SET_BACK_COMPONENT (state, value) {
      state.backToComponent = value
    },
    SET_ITENS_BY_SECTOR (state, value) {
      state.itemsBySector = []
      state.itemsBySector = value
    },
    NEW_ITEM_BY_SECTOR (state, payload) {
      state.itemsBySector.unshift(payload)
    },
    NEW_SECTOR (state, value) {
      console.log(state.sectors)
      state.sectors.unshift(value)
    },
    SET_MAINTENANCES (state, value) {
      state.itensForm.maintenances = []
      state.itensForm.maintenances = value
    },
    SET_ITEM_TO_EDIT (state, value) {
      const data = { ...value }

      if (
        data.values != null ||
        data.values != [null] || data.values != '[null]' ||
        data.values != [[]] || data.values != '[[]]'
      ) {
        try {
          const parsed = JSON.parse(data.values)
          data.values = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : {}
        } catch (error) {
          console.error('Erro ao fazer parse do JSON:', error)
          data.values = {}
        }
      }

      // Atualiza o state
      state.itensForm = data
    },
    SET_TRAINING_COLLECT (state, payload) {
      state.trainingCollect = payload
    },
    SET_QUESTION_COLLECT (state, payload) {
      console.log(payload);
      state.questionsCollect = payload
    },

    //
    SET_FORM (state, payload) {
      console.log(payload)
      state.form = { ...state.form, ...payload }
    },
    SET_TRAININGS (state, payload) { state.trainings = payload || [] },
    RESET_FORM (state) {
      state.form = {
        title: '',
        min_grade_required: 0,
        max_grade: 10,
        max_attempts: 1,
        time_limit_s: null,

        // default
        shuffle_questions: true,
        shuffle_options: true,
        is_active: true,
        event_id: null,
        questionSelected: null,
        answerOptionsCollect: []
      }
    },
    SET_LOADING (state, val) { state.loading = !!val },
    SET_ERRORS (state, payload) { state.errors = payload }
  },
  actions: {
    resetForm ({ commit }) {
      commit('RESET_FORM')
    },
    setAllAssessments ({ commit }, val) {
      commit('SET_ALL_ASSESSMENTS', val)
    },
    setComponentActive ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setPageTitle ({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle ({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },
    setButtonActive ({ commit }, value) {
      commit('SET_IF_BUTTON_ACTIVE', value)
    },
    setBackComponent ({ commit }, value) {
      commit('SET_BACK_COMPONENT', value)
    },
    setItemsBySector ({ commit }, value) {
      commit('SET_ITENS_BY_SECTOR', value)
    },
    addNewSectorCollect ({ commit }, value) {
      commit('NEW_SECTOR', value)
    },
    newItemBySector ({ commit }, value) {
      commit('NEW_ITEM_BY_SECTOR', value)
    },
    setItemToEdit ({ commit }, value) {
      commit('SET_ITEM_TO_EDIT', value)
    },
    setMaintenances ({ commit }, value) {
      commit('SET_MAINTENANCES', value)
    },
    resetMaintenanceForm ({ commit }) {
      commit('RESET_MAINTENANCE')
    },

    // combos
    async getComboTraining ({ commit }) {
      await ExtinguisherService.getComboTraining()
        .then(res => {
          const data = mapIdTitleToValueName(res.data)
          commit('SET_TRAINING_COLLECT', data)
        }).catch(err => {
          console.log(err)
        })
    },
    async getComboQuestion ({ commit }) {
      await ExtinguisherService.questionCollect()
        .then(res => {
          const data = mapIdAndPromtToValueQuestions(res.data)
          commit('SET_QUESTION_COLLECT', data)
        }).catch(err => {
          console.log(err)
        })
    },
    async loadTrainings ({ commit }) {
      // supondo SharedService.getTrainings ou outro endpoint
      try {
        const { data } = await import('@/shared/services/shared').then(m => m.default.getTrainings())
        commit('SET_TRAININGS', data || [])
        return data
      } catch (e) {
        commit('SET_TRAININGS', [])
        return []
      }
    },

    // carregar uma assessment existente para edição
    async loadAssessment ({ commit, state }, assessmentId) {
      try {
        const { data } = await ExtinguisherService.assessmentById(assessmentId)

        const normalizedForm = {
          // id fica no form (edit)
          id: data.id,

          title: data.title,
          min_grade_required: data.min_grade_required,
          max_grade: data.max_grade,
          max_attempts: data.max_attempts,
          time_limit_s: data.time_limit_s,

          shuffle_questions: Boolean(data.shuffle_questions),
          shuffle_options: Boolean(data.shuffle_options),
          is_active: Boolean(data.is_active),

          event_id: mapIdTitleToValueName([data?.event]),

          // selects
          questionSelected: null,

          // questions → select format
          answerOptionsCollect: mapIdTitleToValueName(data.questions || [])
        }
        commit('SET_FORM', normalizedForm)

        storeApp.state.loading = false

        return normalizedForm
      } catch (e) {
        toast(
          'Aviso',
          'Algo deu errado ao buscar dados da prova',
          'error'
        )

        storeApp.state.loading = false

        throw e
      }
    },

    // criar
    async createAssessment ({ state, commit }) {
      commit('SET_LOADING', true)
      try {
        const payload = { ...state.form }
        const { data } = await AssessmentAdminService.create(payload)
        commit('SET_FORM', data)
        commit('SET_LOADING', false)
        return data
      } catch (e) {
        commit('SET_ERRORS', e?.response?.data ?? e)
        commit('SET_LOADING', false)
        throw e
      }
    },

    // atualizar
    async updateAssessment ({ state, commit }) {
      commit('SET_LOADING', true)
      try {
        const { id, ...payload } = state.form
        const { data } = await AssessmentAdminService.update(id, payload)
        commit('SET_FORM', data)
        commit('SET_LOADING', false)
        return data
      } catch (e) {
        commit('SET_ERRORS', e?.response?.data ?? e)
        commit('SET_LOADING', false)
        throw e
      }
    }
  }
})
